import {z} from 'zod';
import {ChatAttachmentReferenceSchema, NativeAttachmentReferenceSchema} from './chat-attachments.js';

// Decoders for the native communication writer and gateway contracts. Native
// message/receipt records remain the only saved conversation and admission state.
const logicalId=z.string().regex(/^[a-f0-9]{64}$/);
const identity=z.string().min(1).max(300);
export const NativeCommunicationProvenanceSchema=z.object({
  version:z.literal(1), producer:z.enum(['user','communication','work']),
  request_id:identity, turn_id:z.uuid(), call_id:z.uuid().optional(), reply_to:logicalId.optional(),
  agent_id:identity.nullable().optional(), result_control_id:z.uuid().optional(), incomplete:z.boolean().optional(),
  attachments:z.array(z.union([ChatAttachmentReferenceSchema,NativeAttachmentReferenceSchema])).optional(),
}).passthrough();
export const NativeCommunicationStateSchema=z.enum(['queued','running','complete','failed','uncertain','cancelled']);
export const NativeCommunicationCapabilitiesSchema=z.object({
  protocol:z.literal(1), attachment_sources:z.array(z.literal('workspace_upload')),live_output:z.literal(1),
}).strict().refine(value=>value.attachment_sources.includes('workspace_upload'),'The runtime does not support verified file admission.');
export const NativeCommunicationReceiptSchema=z.object({
  request_id:identity,turn_id:z.uuid(),status:NativeCommunicationStateSchema,
  user_row_id:z.number().int().positive().nullable(),logical_id:logicalId,
  stored_session_id:identity.nullable(),agent_id:identity.nullable(),
  reply:z.object({row_id:z.number().int().positive(),logical_id:logicalId}).strict().nullish(),
  message_removed:z.boolean().nullish(),reply_removed:z.boolean().nullish(),
  error:z.object({message:z.string(),stack:z.string().optional()}).nullish(),
  selection:z.object({operation_id:z.uuid(),session_id:identity,recorded_at:z.number().positive()}).strict().optional(),
}).strict();
export const NativeCommunicationAdmissionSchema=NativeCommunicationReceiptSchema.extend({
  message:z.record(z.string(),z.unknown()).nullable(),observed_at:z.number().positive(),
}).strict();
export const NativeCommunicationStreamSchema=z.object({
  session_id:identity,request_id:identity,turn_id:z.uuid(),call_id:z.uuid(),agent_id:identity.nullable(),
  reply_to:logicalId,text:z.string(),revision:z.number().int().nonnegative(),started_at:z.number().positive(),
  error:z.object({message:z.string(),stack:z.string().optional(),call_id:z.uuid()}).strict().optional(),
}).strict();
export const NativeCommunicationUpdateSchema=z.object({
  request_id:identity,turn_id:z.uuid(),producer:z.literal('communication'),agent_id:identity.nullable(),
  state:z.enum(['running','streaming','saved','complete','failed','uncertain']),
  call_id:z.uuid().nullish(),delta:z.string().nullish(),revision:z.number().int().nonnegative().nullish(),
  started_at:z.number().positive().nullish(),
  reply:z.object({row_id:z.number().int().positive(),logical_id:logicalId}).strict().nullish(),
  error:z.object({message:z.string(),stack:z.string().optional()}).nullish(),
}).strict();
export type NativeCommunicationStream=z.infer<typeof NativeCommunicationStreamSchema>;
export type NativeCommunicationReceipt=z.infer<typeof NativeCommunicationReceiptSchema>;
export type NativeCommunicationState=z.infer<typeof NativeCommunicationStateSchema>;
